import { actionTypes } from "../actionTypeList";

const initialState = "";

const eventCode = (state = initialState, action) => {
	switch (action.type) {
	    case actionTypes.SET_EVENT_CODE: {
	        return action.payload.eventCode;
	    }
	    default: {
	        return state;
	    }
	}
};

export default eventCode;
